import { render } from "./Account.vue?vue&type=template&id=b56e8b56"
import script from "../js/account.js?vue&type=script&lang=js&external"
export * from "../js/account.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__